module.exports = global["blueslip"] = require("-!./blueslip.js");